export var cifTt = ["301 181", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v180H.5z'/><path fill='#FFF' d='M.5.5l208.248 180H300.5L92.253.5z'/><path fill='#000' d='M15.792.5l208.247 180h61.169L76.961.5z'/></g>"];
